import { atomicParticles } from "./atomic-power";
import { atomMilestones } from "./atom-milestones";
import { atomUpgrades } from "./atom-upgrades";

export const atom = {
  milestones: atomMilestones,
  upgrades: atomUpgrades,
  power: atomicParticles,
};
